import { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import styles from "./PricingTab.module.css";
//IMPORT REDUX ACTIONS
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../../MainWebsiteComponent/store/actions";

const PricingTab = ({ pricing }) => {
  const dispatch = useDispatch();
  const [selectedDiv, setSelectedDiv] = useState(
    useSelector((state) => state.packageType)
  );

  const handleDivClick = (index) => {
    setSelectedDiv(index);
    // console.log(index);
    dispatch(actions.setPackageType(index));
  };

  return (
    <>
      <div className={styles.grandParent}>
        {pricing.map((item, index) => {
          return (
            <div className={styles.parent}>
              <div
                key={index}
                className={
                  selectedDiv === index ? styles.selected : styles.notSelected
                }
                onClick={() => handleDivClick(index)}
              >
                <div className={styles.priceingBox}>
                  {/* priceing type */}
                  <div className={styles.priceingType}>
                    <h5>{item.packageLabel}</h5>
                    {item.mostPopular ? (
                      <span>
                        <WhatshotIcon />
                        Most Popular
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  {/* priceing section */}
                  <div className={styles.priceingSectionParent}>
                    <div className={styles.priceingSection}>
                      <h2>
                        ${item.price} <span>/month</span>
                      </h2>
                      {item.cutprice ? <s>${item.cutprice}/month</s> : <></>}
                    </div>
                    <div className={styles.priceingSectionButton}>
                      <p
                        style={{
                          height: "40px",
                          fontWeight: "500",
                          color: "#0B132B",
                        }}
                      >
                        {item.packagePlan}
                      </p>
                      {/* button section */}
                      {selectedDiv === index ? (
                        <Button
                          variant="contained"
                          fullWidth
                          sx={{
                            padding: "18px 18px !Important",
                            color: "#fff !Important",
                            fontSize: "14px",
                            textTransform: "capitalize !Important",
                            background: "#004FE0 !Important",
                            border: "1px solid #004FE0 !Important",
                            borderRadius: "10px !Important",
                            display: "flex !Important",
                            justifyContent: "space-between !Important",
                            boxShadow: "none !Important",
                          }}
                          endIcon={<CheckCircleRoundedIcon />}
                        >
                          Selected
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          fullWidth
                          sx={{
                            padding: "18px 18px !Important",
                            color: "#004FE0 !Important",
                            textTransform: "capitalize !Important",
                            background: "#fff !Important",
                            fontSize: "14px",
                            borderRadius: "10px !Important",
                            border: "1px solid #E4E8EC",
                            display: "flex !Important",
                            justifyContent: "space-between !Important",
                            boxShadow: "none !Important",
                            border: "1px solid #E4E8EC !Important",
                          }}
                          endIcon={
                            <CheckCircleRoundedIcon
                              sx={{ color: "#D2D3D8 !Important" }}
                            />
                          }
                        >
                          Select
                        </Button>
                      )}
                    </div>

                    {/* list section */}
                    <div className={styles.listSectionParent}>
                      <h6>Includes</h6>
                      <div className={styles.listItemParent}>
                        {/* list item */}
                        {item.includes.map((includeItem, index) => {
                          return (
                            <div className={styles.listItem} key={index}>
                              <div className={styles.packageItem}>
                                {includeItem.strong ? (
                                  <span>
                                    <strong>{includeItem.strong}&nbsp;</strong>
                                    {includeItem.details}
                                  </span>
                                ) : (
                                  <span>{includeItem.details}</span>
                                )}
                              </div>
                              <div>
                                <Tooltip
                                  title={includeItem.tooltip}
                                  placement="top"
                                  arrow
                                >
                                  <InfoOutlinedIcon
                                    sx={{ opacity: "20%" }}
                                    fontSize="small"
                                  />
                                </Tooltip>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {/* list section end */}
                  </div>
                </div>
              </div>
              {/* bottom swtich */}
              <div className={styles.bottomSection}>
                <div className={styles.switcheSectionParent}>
                  <div className={styles.switcheSectionTypography}>
                    <p>Take Attendance</p>
                    <span>+ $4/month</span>
                  </div>
                  {/* toggle button */}
                  <label className={styles.switch}>
                    <input type="checkbox" />
                    <span className={styles.slider}></span>
                  </label>
                </div>
                {/* switche section */}
                <div className={styles.switcheSectionParent}>
                  <div className={styles.switcheSectionTypography}>
                    <p>Grade Exams</p>
                    <span>+ $4/month</span>
                  </div>
                  {/* toggle button */}
                  <label className={styles.switch}>
                    <input type="checkbox" />
                    <span className={styles.slider}></span>
                  </label>
                </div>
              </div>
              <div className={styles.sectionSingleFooter}>
                <p>+$485 One-time Setup Cost for all plans</p>
              </div>
            </div>
          );
        })}
      </div>
      {/* section footer */}
      <div className={styles.sectionFooter}>
        <p>+$485 One-time Setup Cost for all plans</p>
      </div>
    </>
  );
};

export default PricingTab;
